export default "__VITE_ASSET__Ixx5X2ce__"